export enum ContentItemTypeValues {
  AR = "AR",
  VR = "VR",
  MATTERPORT_SCENE = "MATTERPORT_SCENE",
  MATTERPORT_ASSET = "MATTERPORT_ASSET",
  NEWSLETTER = "NEWSLETTER",
  RENDERED_VT = "RENDERED_VT",
}
